/**
 * Animation on scroll (AOS)
 *
 * @requires https://github.com/michalsnik/aos
 */

import vendorMissing from './vendor-missing'
import onFragment, { within } from './on-fragment'

let started = false

const start = () => {
  if (vendorMissing('animation on scroll', { AOS: typeof AOS })) return
  started = true

  AOS.init() // eslint-disable-line no-undef

  // AOS caches every trigger position at init and re-measures only on
  // resize, orientationchange and when [data-aos] nodes are added - never on
  // load. Anything that changes the document height afterwards leaves the
  // cached triggers below the elements' real positions, and every animation
  // further down fires too late. Two known causes: swiper initialises after
  // AOS in this very bundle (a slider with three slides per view is one
  // full-width slide tall until then - 1317px against 450px on
  // landing-saas-v4, so the section below it animated a viewport late), and
  // lazy images or SVGs with bogus intrinsic dimensions. Re-measure whenever
  // the page height settles. Observing body alone is not enough: under
  // Plone body is exactly one viewport high (height: 100%) and the content
  // overflows it, so body never resizes - the wrappers directly inside it
  // do. This lived as a hand patch in assets/js/theme.js once and was lost
  // in a rebuild (45dde9d0); it belongs in the source.
  if ('ResizeObserver' in window) {
    let refreshTimer
    const observer = new ResizeObserver(() => {
      clearTimeout(refreshTimer)
      refreshTimer = setTimeout(() => AOS.refresh(), 150) // eslint-disable-line no-undef
    })
    observer.observe(document.body)
    for (const child of document.body.children) observer.observe(child)
  } else {
    window.addEventListener('load', () => AOS.refresh()) // eslint-disable-line no-undef
  }
}

// AOS hides every [data-aos] element until it animates it, so it has to run
// wherever one is - also when the first one arrives in a fragment htmx swaps
// in (an expanded listing card) on a page that had none. Once running, its
// own MutationObserver picks up [data-aos] nodes added later.
export default (() => {
  onFragment((root) => {
    if (started || within(root, '[data-aos]').length === 0) return
    start()
  })
})()
